import { useLayoutEffect, useState, type RefObject } from 'react';

export function useIsAtBottom(ref: RefObject<HTMLElement | null>) {
  const [isAtBottom, setIsAtBottom] = useState(true);

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    const element = ref.current;

    const handleScroll = () => {
      // Because we use `column-reverse`, the "top" is actually at the bottom, and scrollTop becomes negative as you scroll up
      const newIsAtBottom = element.scrollTop >= -1;
      if (newIsAtBottom !== isAtBottom) {
        setIsAtBottom(newIsAtBottom);
      }
    };

    element.addEventListener('scroll', handleScroll);
    return () => element.removeEventListener('scroll', handleScroll);
  }, [isAtBottom, ref]);

  return isAtBottom;
}
